import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import Swal from "sweetalert2";
import { MarcarPorRevisar } from "../../components/Calificaciones/MarcarPorRevisar";
import { VerEvaluacionesPrecalificacionesFuncionario } from "../../components/Calificaciones/VerEvaluacionesPrecalificacionesFuncionario";
import { InformacionFuncionario } from "../../components/EtapasDeCalificacion/InformacionFuncionario";
import { ModalDocumento } from "../../components/Otros/ModalDocumento";
import { ModalActualizarCalificacion } from "../../components/Ratificaciones/ModalActualizarCalificacion";
import { useForm } from "../../hooks/useForm";
import { cargarCalificacionFinal } from "../../utils/Datos";
import { Textos, UrlWs } from "../../utils/Global";

async function enviarRatificar(payload) {
  const url =UrlWs+ `/ratifications`;
  const datos = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 400) {
      return { status: false, errores: respuesta.errors };
    } else {
      return { status: true, datos: respuesta };
    }
  });
  return datos;
}

export const Ratificar = () => {
  const { id_participant, id_qualifications ,id_session} = useParams();

  const [cargando, setCargando] = useState(false);
  const [puedeRatificar, setPuedeRatificar] = useState(false);
  const [{ comentario }, handleInputChange] = useForm({ comentario: "" });
  const [datosCalificacionFinal, setdatosCalificacionFinal] = useState(null);

  useEffect(() => {
    cargarCalificacionFinal(id_participant).then((calificacionfinal) => {
      if (calificacionfinal !== null) {
        if (calificacionfinal.status) {
          setdatosCalificacionFinal(calificacionfinal);
        } else {
          setdatosCalificacionFinal(null);
        }
      }
    });
  }, []);

  const handleClick = async () => {
    setCargando(true);
    const payload = {
      ratificationCommentary: comentario,
      id_qualifications: id_qualifications,
      //ratificationStatus: true,
      id_session:id_session
      //sesion id
    };
    enviarRatificar(payload).then((respuesta) => {
      if (respuesta.status === true) {
        Swal.fire({
          title: "Listo",
          text: "Ratificación enviada",
          icon: "success",
          confirmButtonText: "Ok",
        }).then((okay) => {
          if (okay) {
            window.location.href = "/calificacionesPendientes";
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text: respuesta.errores ?? "Ocurrió un error",
          icon: "error",
          confirmButtonText: "Ok",
        }).then((okay) => {
          if (okay) {
            window.location.href = "/calificacionesPendientes";
          }
        });
      }
      setCargando(false);
    });
  };

  return (
    <>
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div className="toolbar" id="kt_toolbar">
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
                 Ratificar
              </h1>
              <span className="h-20px border-gray-300 border-start mx-4" />
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-300 w-5px h-2px" />
                </li>
                <li className="breadcrumb-item text-dark">
                  {" "}
                  INFORMACIÓN DE LA SESIÓN
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <InformacionFuncionario
                      id_participant={id_participant}
                      boton_historial={false}
                    ></InformacionFuncionario>
                  </div>
                </div>
              </div>
              <div className="col-xl-12 ">
                <div className="card ">
                  <div className="card-header ">
                    <h3 className="card-title align-items-start flex-column ">
                      <span className="card-label fw-bolder text-dark ">
                         VER EVALUACIONES Y PRECALIFICACIONES DEL
                        FUNCIONARIO
                      </span>
                    </h3>
                  </div>
                  <div className="card-body ">
                    <div className="table-responsive ">
                      <VerEvaluacionesPrecalificacionesFuncionario
                        id_participant={id_participant}
                        setPuedeRatificar={setPuedeRatificar}
                      ></VerEvaluacionesPrecalificacionesFuncionario>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <h4 className="text-gray-900 fw-bolder mt-5 mb-5">
                          Calificación Final
                        </h4>
                      </div>
                      <div className="col-md-12">
                        <div className="table-responsive mt-8">
                          {datosCalificacionFinal === null ? (
                            <div className="alert alert-warning" role="alert">
                              <strong>
                                <i className="fas fa-exclamation-triangle"></i>
                              </strong>
                              La etapa de calificación aún no ha sido realizada
                            </div>
                          ) : datosCalificacionFinal.datos !==
                            null ? (
                            <table className="table table-rounded  border gy-7 gs-7 table-bordered">
                              <thead>
                                <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200 ">
                                  
                                  <th>SF11</th>
                                  <th>SF12</th>
                                  <th>NOTA</th>
                                  <th>PTJE F1</th>
                                  <th>SF21</th>
                                  <th>SF22</th>
                                  <th>SF23</th>
                                  <th>NOTA</th>
                                  <th>PTJE F2</th>
                                  <th>SF31</th>
                                  <th>SF32</th>
                                  <th>NOTA</th>
                                  <th>PTJE F3</th>
                                  <th>FINAL</th>
                                  <th>LISTA</th>
                               
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                 
                                  key={`tr_calificacionfinal`}
                                >
                                  
                                  <td>
                                    {datosCalificacionFinal.datos.subFactor11}
                                  </td>
                                  <td>
                                    {datosCalificacionFinal.datos.subFactor12}
                                  </td>
                                  <td>
                                    {
                                      datosCalificacionFinal.datos
                                        .qualificationFactor1
                                    }
                                  </td>
                                  <td>
                                    {datosCalificacionFinal.datos.scoreFactor1}
                                  </td>
                                  <td>
                                    {datosCalificacionFinal.datos.subFactor21}
                                  </td>
                                  <td>
                                    {datosCalificacionFinal.datos.subFactor22}
                                  </td>
                                  <td>
                                    {datosCalificacionFinal.datos.subFactor23}
                                  </td>
                                  <td>
                                    {
                                      datosCalificacionFinal.datos
                                        .qualificationFactor2
                                    }
                                  </td>
                                  <td>
                                    {datosCalificacionFinal.datos.scoreFactor2}
                                  </td>
                                  <td>
                                    {datosCalificacionFinal.datos.subFactor31}
                                  </td>
                                  <td>
                                    {datosCalificacionFinal.datos.subFactor32}
                                  </td>
                                  <td>
                                    {
                                      datosCalificacionFinal.datos
                                        .qualificationFactor3
                                    }
                                  </td>
                                  <td>
                                    {datosCalificacionFinal.datos.scoreFactor3}
                                  </td>
                                  <td>
                                    <span className="badge badge-primary">
                                      {datosCalificacionFinal.datos.finalScore}
                                    </span>
                                  </td>
                                  <td>{datosCalificacionFinal.datos.list}</td>
                                  
                                </tr>
                              </tbody>
                            </table>
                          ) : (
                            <>
                              <div className="alert alert-warning" role="alert">
                                <strong>
                                  <i className="fas fa-exclamation-triangle"></i>
                                </strong>{" "}
                                La calificación no ha sido ratificada
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 text-end mb-3">
                        <button
                          className="btn btn-primary botonHeader mr2"
                          data-bs-toggle="modal"
                          data-bs-target={`#modal`}
                          disabled={!puedeRatificar}
                        >
                           Actualizar Calificación
                        </button>
                        <MarcarPorRevisar
                          id_qualifications={id_qualifications}
                        ></MarcarPorRevisar>
                      </div>
                    </div>
                    <textarea
                      className="form-control mb-5"
                      rows={5}
                      cols={20}
                      placeholder={"Ingresar comentario"}
                      value={comentario}
                      name="comentario"
                      onChange={handleInputChange}
                    />
                    <div className="d-flex flex-stack">
                      <button
                        className=" btn btn-sm btn-primary"
                        onClick={handleClick}
                        disabled={cargando || !puedeRatificar}
                      >
                        {cargando ? " Ratificando..." : " Ratificar"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalActualizarCalificacion
        id_participant={id_participant}
      ></ModalActualizarCalificacion>

      {datosCalificacionFinal !== null &&
      datosCalificacionFinal.datos.qualificationDocument != null &&
      datosCalificacionFinal.datos.qualificationDocument.contentByte != null ? (
        <ModalDocumento
          id="modalCalificacionFinal"
          documentoByte={
            datosCalificacionFinal !== null
              ? datosCalificacionFinal.datos.qualificationDocument.contentByte
              : null
          }
        />
      ) : (
        <></>
      )}
    </>
  );
};
